export * from './information-dialog'
